import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.sort.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-573bdd48"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 新增分类 ");

const _hoisted_2 = {
  class: "sort"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sales-prod-scope-label"
}, "与上级团队一致", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sales-prod-scope-tip"
}, "按上级团队商品范围销售", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sales-prod-scope-label"
}, "自定义选择商品", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sales-prod-scope-tip"
}, "需自主选择加入商品", -1));

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_10 = {
  class: "drug-toolbar-actions"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("添加");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("Excel导入");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("维护分类");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除分类");

const _hoisted_16 = /*#__PURE__*/_createTextVNode("价格同步设置");

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "drug-shelf-tip"
}, "商业与团队均为上架状态卖品才可见进行加购下单", -1));

const _hoisted_18 = {
  style: {
    "line-height": "1.2",
    "position": "relative"
  }
};
const _hoisted_19 = {
  class: "padding-right: 25px;"
};
const _hoisted_20 = {
  style: {
    "padding-right": "25px"
  }
};
const _hoisted_21 = {
  style: {
    "line-height": "1.2"
  }
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "underline"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "underline"
};
const _hoisted_26 = {
  style: {
    "line-height": "1.2"
  }
};
const _hoisted_27 = ["onMouseenter"];
const _hoisted_28 = {
  class: "storage-detail"
};
const _hoisted_29 = {
  style: {
    "line-height": "1.2"
  }
};
const _hoisted_30 = {
  style: {
    "line-height": "1.2",
    "position": "relative"
  }
};

const _hoisted_31 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_32 = {
  style: {
    "line-height": "1.2"
  }
};

const _hoisted_33 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_34 = {
  key: 0
};

const _hoisted_35 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1.请下载Excel模版，填写发货方名称，商品编码，药品分类，保存后上传到系统。", -1));

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2.商品编码格式错误无法匹配上系统内客户的数据会提示导入失败。", -1));

const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 3.药品分类填写错误无法匹配上系统设置的分类名称会导入失败，如某药品无分类，则该药品类型不填写。 ", -1));

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4.一次最多导入3000条数据，超出数量会导入失败。", -1));

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "red"
  }
}, "商品最低销售价设置价格即视为允许改价", -1));

const _hoisted_41 = /*#__PURE__*/_createTextVNode("自动获取商业公司价格与配置");

const _hoisted_42 = /*#__PURE__*/_createTextVNode("自主设置");

const _hoisted_43 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_44 = /*#__PURE__*/_createTextVNode("确定");

import Sortable from 'sortablejs';
import { reactive, ref, watch, onMounted, nextTick, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { sellingDrugsList, deleteSupMer, getCategoryList, sortCategory, updateDrugsCategory, delCategory as delCategoryRequest, getSupPriceStrategy, setSupPriceStrategy, setSupMerchandiseSellStatus, getSupMerchandiseOwnerStorage, updateSalesProdScope } from '@/request';
import { uploadMerchandiseInfo, importMerchandiseExcel } from '@/request/api';
import { getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import UploadModal from '@/components/UploadModal.vue';
import PanelWrapper from '@/components/PanelWrapper.vue';
import AddDrugsModal from './AddDrugsModal.vue';
import AddCategoryModal from './AddCategoryModal.vue';
import SelectCategoryModal from './SelectCategoryModal.vue';
import UpdateBottomPriceModal from './UpdateBottomPriceModal.vue';
import Axios from '@/request/createAxiosInstalce';
import EditTeamPriceModal from './EditTeamPriceModal.vue';
import ProductDetailModal from './ProductDetailModal.vue';
import MerchandiseBlacklistModal from './MerchandiseBlacklistModal.vue';
export default {
  name: 'SellingDrugs',
  props: {
    dept: {
      type: Object,
      default: () => ({})
    },
    supplierId: {
      type: String,
      defualt: ''
    },
    storageType: Number
  },

  setup(__props) {
    const props = __props;
    const store = useStore();
    /** 仅分管可编辑团队上架状态（userType=2） */

    const canEditTeamSellStatus = computed(() => Number(store.state.user.userType) === 2); // 定义销售状态的映射和辅助函数

    const SELL_STATUS_MAP = {
      0: '待上架',
      1: '已上架',
      2: '已下架',
      3: '暂停销售'
    };
    const SELL_STATUS_TYPE = {
      0: 'warning',
      // 待上架 - 黄色
      1: 'success',
      // 已上架 - 绿色
      2: 'danger',
      // 已下架 - 红色
      3: 'danger' // 暂停销售 - 红色

    };

    const getBusinessShelfStatusText = status => {
      return SELL_STATUS_MAP[status] || '未知';
    };

    const getStatusType = status => {
      return SELL_STATUS_TYPE[status] || 'info';
    }; // 获取库存详情


    const getStorageDetails = row => {
      // 检查行数据中是否有库存详情，如果没有则返回默认值
      if (row.storageDetails && Array.isArray(row.storageDetails)) {
        return row.storageDetails;
      } // 如果没有具体的库存详情数据，可以根据现有数据构造一个默认显示
      // 这里假设单条数据作为默认显示


      if (row.storageNumber !== undefined) {
        return [{
          warehouseName: '仓库信息',
          location: '货位信息',
          storageNumber: row.storageNumber
        }];
      }

      return [];
    };

    const storageDetailsData = ref([]);
    const storageDetailsLoading = ref(false);

    function normalizeSalesProdScope(val) {
      const n = Number(val);
      return n === 2 ? 2 : 1;
    }

    const salesProdScopeModel = ref(1);
    const scopeSaving = ref(false);
    watch(() => props.dept, dept => {
      var _dept$salesProdScope;

      const scope = normalizeSalesProdScope((_dept$salesProdScope = dept === null || dept === void 0 ? void 0 : dept.salesProdScope) !== null && _dept$salesProdScope !== void 0 ? _dept$salesProdScope : dept === null || dept === void 0 ? void 0 : dept.sales_prod_scope);
      salesProdScopeModel.value = scope;
    }, {
      immediate: true,
      deep: true
    });

    function onSalesProdScopeIntent(_x) {
      return _onSalesProdScopeIntent.apply(this, arguments);
    }

    function _onSalesProdScopeIntent() {
      _onSalesProdScopeIntent = _asyncToGenerator(function* (intentVal) {
        const newVal = normalizeSalesProdScope(intentVal);
        const current = salesProdScopeModel.value;

        if (newVal === current || scopeSaving.value) {
          return;
        }

        try {
          yield ElMessageBox.confirm('修改后会影响用户的可见商品范围，确认修改吗？', '请确认', {
            type: 'warning',
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          });
        } catch (_unused) {
          return;
        }

        scopeSaving.value = true;

        try {
          const data = yield updateSalesProdScope({
            supplierId: props.supplierId,
            structureId: props.dept.id,
            salesProdScope: newVal,
            __warn: true,
            __repeat: true
          });

          if (data.success) {
            ElMessage.success('修改成功');
            salesProdScopeModel.value = newVal;

            if (props.dept) {
              props.dept.salesProdScope = newVal;
            }

            if (newVal === 2) {
              yield nextTick();

              if (table.value) {
                table.value.commitProxy('reload');
              }
            }
          }
        } finally {
          scopeSaving.value = false;
        }
      });
      return _onSalesProdScopeIntent.apply(this, arguments);
    }

    const isRootDept = computed(() => {
      var _props$dept;

      return Number((_props$dept = props.dept) === null || _props$dept === void 0 ? void 0 : _props$dept.levelType) === 0;
    });
    const isCustomSalesProd = computed(() => salesProdScopeModel.value === 2);
    const showDrugMaintain = computed(() => isRootDept.value || isCustomSalesProd.value); // 加载库存详情数据

    const loadStorageDetails = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (row) {
        // 设置loading状态
        storageDetailsLoading.value = true; // 先清空之前的数据

        storageDetailsData.value = [];

        try {
          const response = yield getSupMerchandiseOwnerStorage({
            branchId: row.branchId,
            storeProdNo: row.prodNo
          });

          if (response.success && response.data && Array.isArray(response.data)) {
            storageDetailsData.value = response.data.map(item => ({
              ware_house_id: item.ware_house_name ? `${item.ware_house_name}/${item.ware_house_id}` : item.ware_house_id,
              owner_id: item.owner_name ? `${item.owner_name}/${item.owner_id}` : item.owner_id,
              storage_number: item.storage_number,
              deposit_storage_number: item.deposit_storage_number,
              available_storage_number: Math.max(0, (item.storage_number || 0) - (item.deposit_storage_number || 0))
            }));
          } else {
            storageDetailsData.value = [];
          }
        } catch (error) {
          console.error('获取库存详情失败:', error);
          storageDetailsData.value = [];
        } finally {
          // 确保无论成功或失败都关闭loading状态
          storageDetailsLoading.value = false;
        }
      });

      return function loadStorageDetails(_x2) {
        return _ref.apply(this, arguments);
      };
    }();

    const route = useRoute();
    const storeType = Number(route.query.storeType);
    const cateTable = ref();
    const showSelectCateModal = ref(false);
    const editCategoryData = ref(null);
    const categoryList = ref([]);
    const showAddCateModal = ref(false);
    const selectCategory = ref(null);
    const table = ref();
    const uid = ref(0);

    function initCategoryListData() {
      getCategoryList({
        supplierId: props.supplierId,
        structureId: props.supplierId === props.dept.id ? '' : props.dept.id
      }).then(data => {
        if (data.success) {
          var _data$data;

          categoryList.value = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.sort((a, b) => a.sort - b.sort);
        }
      });
    }

    function updateCategorySuccess() {
      initCategoryListData();
      table.value.commitProxy('reload');
    }

    function initSortTable() {
      let el = cateTable.value.$el.querySelector('.vxe-table--body tbody');
      let sortable = Sortable.create(el, {
        animation: 150,
        list: categoryList.value,
        dragClass: 'sortable-drag',

        onEnd(e) {
          const {
            newIndex,
            oldIndex
          } = e;
          let old = categoryList.value[oldIndex];
          categoryList.value.splice(oldIndex, 1);
          categoryList.value.splice(newIndex, 0, old); // 需要重新销毁dom 然后重新初始化渲染
          // sortjs 改变了 dom结构 导致 vue render渲染的时候 更新出错

          uid.value++;
          nextTick(() => {
            initSortTable();
          });
          sortCategory(categoryList.value.map((i, idx) => ({
            merTypeId: i.merTypeId,
            name: i.typeName,
            sort: idx + 1
          }))).then(data => {
            initCategoryListData();
          });
        }

      });
    }

    onMounted(() => {
      initSortTable();
    });
    initCategoryListData();

    function addCategory() {
      showAddCateModal.value = true;
      selectCategory.value = null;
    }

    function editCate(row) {
      showAddCateModal.value = true;
      selectCategory.value = row;
    }

    function delCategory(row) {
      sellingDrugsList({
        page: 0,
        rows: 10,
        supplierId: props.supplierId,
        merTypeId: row.merTypeId,
        structureId: Number(props.dept.levelType) === 0 ? '' : props.dept.id,
        __warn: true
      }).then(res => {
        let warnNode = '';

        if (res.total > 0) {
          warnNode = '<i style="color:red">该分类已关联商品</i>,';
        }

        ElMessageBox.confirm(`是否确认删除这条数据<br/>
       <span style="font-size:12px">注意:${warnNode}操作删除后，分类名称信息从分类列表中删除，已维护到当前分类的药品分类标签清空</span>`, {
          dangerouslyUseHTMLString: true
        }).then(() => {
          delCategoryRequest({}, {
            params: {
              merTypeId: row.merTypeId,
              __repeat: true,
              __warn: true
            }
          }).then(data => {
            if (data.success) {
              ElMessage.success('操作成功!');
              initCategoryListData();

              if (res.total > 0) {
                table.value.commitProxy('reload');
              }
            }
          });
        });
      });
    }

    const form = reactive({
      supMerInfo: ''
    });
    const showUploadModel = ref(false);
    const showAddDrugsModal = ref(false);
    let uploadOption = ref({
      action: uploadMerchandiseInfo.url,
      name: 'merchandise_excel',
      data: {
        supplierIdThree: props.supplierId,
        structureIdThree: props.supplierId === props.dept.id ? '' : props.dept.id
      },
      templateLink: importMerchandiseExcel.url,
      title: '导入'
    }); // 切换组织 重新获取数据（药品维护面板未展示时不刷新列表，避免仅改可售范围时多余请求）

    function initData() {
      form.supMerInfo = '';

      if (table.value && showDrugMaintain.value) {
        table.value.commitProxy('reload');
      }

      initCategoryListData(); // 更新分类列表

      uploadOption.value = {
        action: uploadMerchandiseInfo.url,
        name: 'merchandise_excel',
        data: {
          supplierIdThree: props.supplierId,
          structureIdThree: props.supplierId === props.dept.id ? '' : props.dept.id
        },
        templateLink: importMerchandiseExcel.url,
        title: '导入'
      };
    }

    watch(() => props.dept, () => {
      initData();
    });
    const tableShow = ref(true);
    watch(() => props.storageType, v => {
      if (v === 1) {
        columns[columns.length - 1].title = '货主库存';
        table.value.reloadColumn(columns);
      }
    });

    function del() {
      // 删除药品
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`是否确认删除${selectRows.length}条数据`, '确认删除').then(() => {
        deleteSupMer({
          __repeat: true,
          __warn: true,
          supplierId: props.supplierId,
          merInfo: selectRows.map(i => `${i.branchId}|${i.prodNo}`).join(','),
          structureId: Number(props.dept.levelType) === 0 ? '' : props.dept.id
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    let selectDrugs = [];

    function maintainCategory() {
      // 维护分类
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      showSelectCateModal.value = true;
      selectDrugs = selectRows;
    }

    function updateDrugsCategorySuccess(typeId) {
      let payload = {
        supMerIds: selectDrugs.map(i => i.supMerchandiseId).join(','),
        __repeat: true,
        __warn: true
      };

      if (typeId) {
        payload.typeId = typeId;
      }

      updateDrugsCategory(payload).then(data => {
        if (data.success) {
          showSelectCateModal.value = false;
          table.value.clearCheckboxRow();
          ElMessage.success('操作成功');
          table.value.commitProxy('query');
        }
      });
    }

    function uploadSuccess() {
      table.value.commitProxy('reload');
    }

    function delDrugsCategory() {
      // 维护删除药品分类
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      selectDrugs = selectRows;
      ElMessageBox.confirm('是否清除选择商品的所属分类').then(() => {
        updateDrugsCategorySuccess('');
      });
    }

    const columns = [{
      type: 'checkbox',
      width: '50px',
      fixed: 'left'
    }, {
      title: storeType === 1 ? '厂家' : '发货方',
      field: 'branchName',
      width: '200px',
      showOverflow: true
    }, {
      title: '商品',
      field: 'prodNo',
      width: '220px',
      slots: {
        default: 'productInfo'
      }
    }, {
      title: '商业上架状态',
      field: 'businessShelfStatus',
      width: '120px',
      slots: {
        default: 'businessShelfStatus'
      }
    }, {
      title: '团队上架状态',
      field: 'supplierSellStatus',
      width: '160px',
      slots: {
        default: 'teamShelfStatus'
      }
    }, {
      title: '规格/厂家',
      field: 'prodSpecification',
      width: '300px',
      slots: {
        default: 'specificationInfo'
      }
    }, {
      title: '可售库存（默认仓）',
      field: 'storageNumber',
      width: '100px',
      slots: {
        default: 'storageInfo'
      }
    }, {
      title: '业务员进货价',
      field: 'teamIncomePriceInfoList',
      width: '200px',
      slots: {
        default: 'teamIncomePriceInfo'
      }
    }, {
      title: '负责人进货价格',
      field: 'teamSalePriceInfoList',
      width: '200px',
      slots: {
        default: 'teamSalePriceInfo'
      }
    }, {
      title: '分类',
      field: 'typeName',
      width: '100px',
      showOverflow: true
    }, {
      title: '客户销售价',
      field: 'bottomPrice',
      width: '200px',
      slots: {
        default: 'priceInfo'
      }
    }, {
      title: '排序',
      field: 'sort',
      width: '160px',
      slots: {
        default: 'sort'
      }
    }, {
      title: '销售员黑名单',
      field: 'blacklistSalesmanNumber',
      width: '160px',
      slots: {
        default: 'blacklistSalesmanInfo'
      }
    }];
    const tablePage = {
      pageSizes: [10, 50, 100, 200]
    };
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        custom: true,
        refresh: true,
        zoom: true
      },
      columns,
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            sellingDrugsList(_objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId: props.supplierId
            }, form), {}, {
              structureId: Number(props.dept.levelType) === 0 ? '' : props.dept.id,
              __warn: true
            })).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function sortValueChange(v, row) {
      let sort = v ? v : '';
      let url = `/admin/supplier/setSupMerchandiseSort?sort=${sort}&supMerchandiseId=${row.supMerchandiseId}`;
      Axios.post(url).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function teamSellStatusChange(v, row) {
      if (!canEditTeamSellStatus.value) {
        return;
      }

      const supplierSellStatus = Number(v);
      const prevStatus = Number(row.supplierSellStatus) === 0 ? 0 : 1;
      row.supplierSellStatus = supplierSellStatus;
      setSupMerchandiseSellStatus({
        supMerchandiseId: row.supMerchandiseId,
        supplierSellStatus
      }).then(res => {
        const {
          success,
          msg
        } = res;

        if (success) {
          ElMessage.success(supplierSellStatus === 1 ? '已上架' : '已下架');
        } else {
          row.supplierSellStatus = prevStatus;
          ElMessage.error(msg || '操作失败');
        }
      }).catch(() => {
        row.supplierSellStatus = prevStatus;
        ElMessage.error('操作失败');
      });
    }

    const selectedRow = ref(null);
    const showUpdateBottomPriceModal = ref(false);

    function updatebottomPrice(row) {
      selectedRow.value = row;
      showUpdateBottomPriceModal.value = true;
    }

    function updatebottomPriceSuccess() {
      table.value.commitProxy('query');
      console.log('修改成功!');
    } // 价格同步设置


    const drugEqualModal = reactive({
      show: false,
      value: '1'
    });

    function getSupPriceStrategyFetch() {
      getSupPriceStrategy({
        supplierId: props.supplierId
      }).then(res => {
        drugEqualModal.value = String(res.data);
        drugEqualModal.show = true;
      });
    }

    function setSupPriceStrategyFetch() {
      let body = {
        supplierId: props.supplierId,
        priceSyncStrategy: drugEqualModal.value
      };
      setSupPriceStrategy(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
          drugEqualModal.show = false;
        } else {
          ElMessage.error(msg);
        }
      });
    } // 一键获取商业公司价格配置


    function getCompanyPriceSetting() {
      ElMessageBox.confirm('获取商业公司价格会覆盖所有自主设置的价格，操作不可撤回，是否确认操作？', '请确认', {
        type: 'warning'
      }).then(() => {});
    } // 编辑团队进货价和销售价


    const showTeamPriceModal = ref(false);
    const selectedTeamPriceRow = ref(null);

    function editTeamPrice(row) {
      selectedTeamPriceRow.value = row;
      console.log(selectedTeamPriceRow.value);
      showTeamPriceModal.value = true;
    } // 编辑团队进货价和销售价成功后刷新列表


    function handleTeamPriceSuccess() {
      table.value.commitProxy('reload');
    }

    const showProductDetail = ref(false);
    const selectedProduct = ref(null);

    function showProductDetailModal(row) {
      selectedProduct.value = row;
      showProductDetail.value = true;
    }

    const showMerchandiseBlacklistModal = ref(false);
    const selectBlacklistRow = ref(null);

    function editMerchandiseBlacklist(row) {
      selectBlacklistRow.value = row;
      showMerchandiseBlacklistModal.value = true;
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_vxe_column = _resolveComponent("vxe-column");

      const _component_Rank = _resolveComponent("Rank");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_vxe_table = _resolveComponent("vxe-table");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(PanelWrapper, {
        title: "药品分类"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: addCategory,
          style: {
            "margin-bottom": "10px"
          }
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_alert, {
          type: "info",
          "show-icon": "",
          title: "可按住分类进行拖拽排序",
          style: {
            "margin-bottom": "10px"
          }
        }), (_openBlock(), _createBlock(_component_vxe_table, {
          key: uid.value,
          align: "center",
          data: categoryList.value,
          ref_key: "cateTable",
          ref: cateTable
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            title: "序号",
            field: "sort"
          }, {
            default: _withCtx(({
              rowIndex
            }) => [_createElementVNode("span", _hoisted_2, _toDisplayString(rowIndex + 1), 1)]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "typeName",
            title: "名称"
          }), _createVNode(_component_vxe_column, {
            title: "操作",
            width: "200px"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Edit",
              onClick: $event => editCate(row)
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "danger",
              icon: "Delete",
              onClick: $event => delCategory(row)
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          }), _createVNode(_component_vxe_column, null, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              size: "large"
            }, {
              default: _withCtx(() => [_createVNode(_component_Rank)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]))]),
        _: 1
      }), !_unref(isRootDept) ? (_openBlock(), _createBlock(PanelWrapper, {
        key: 0,
        title: "药品范围"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_radio_group, {
          "model-value": salesProdScopeModel.value,
          class: "sales-prod-scope-group",
          "onUpdate:modelValue": onSalesProdScopeIntent
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [_hoisted_5, _hoisted_6]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 2
          }, {
            default: _withCtx(() => [_hoisted_7, _hoisted_8]),
            _: 1
          })]),
          _: 1
        }, 8, ["model-value"])), [[_directive_loading, scopeSaving.value]])]),
        _: 1
      })) : _createCommentVNode("", true), _unref(showDrugMaintain) ? (_openBlock(), _createBlock(PanelWrapper, {
        key: 1,
        title: "药品维护"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "drug-search-row"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            style: {
              "width": "200px",
              "margin-right": "10px"
            },
            modelValue: form.supMerInfo,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.supMerInfo = $event),
            placeholder: "发货方/编码/名称/分类",
            onKeydown: _cache[1] || (_cache[1] = _withKeys($event => table.value.commitProxy('reload'), ["enter"]))
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[3] || (_cache[3] = $event => showAddDrugsModal.value = true)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          icon: "Delete",
          onClick: del
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "UploadFilled",
          onClick: _cache[4] || (_cache[4] = $event => showUploadModel.value = true)
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: maintainCategory
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: delDrugsCategory
        }, {
          default: _withCtx(() => [_hoisted_15]),
          _: 1
        }), Number(__props.dept.levelType) === 0 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: getSupPriceStrategyFetch
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        })) : _createCommentVNode("", true)]), _hoisted_17, tableShow.value ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0
        }, _unref(tableOptions), {
          "pager-config": tablePage,
          ref_key: "table",
          ref: table,
          class: "drug-table"
        }), {
          priceInfo: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, "销售价：" + _toDisplayString(row.salePriceStr), 1), _createElementVNode("div", _hoisted_20, "最低销售价：" + _toDisplayString(row.bottomPrice || '-'), 1), __props.dept.levelType === '0' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: $event => updatebottomPrice(row),
            link: "",
            icon: "Edit",
            type: "primary",
            style: {
              "position": "absolute",
              "right": "10px",
              "top": "50%",
              "transform": "translateY(-50%)"
            }
          }, null, 8, ["onClick"])) : _createCommentVNode("", true)])]),
          sort: _withCtx(({
            row
          }) => [_createVNode(_component_el_input_number, {
            modelValue: row.sort,
            "onUpdate:modelValue": $event => row.sort = $event,
            min: 1,
            precision: 0,
            onChange: v => sortValueChange(v, row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          productInfo: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
            class: "product-link",
            onClick: $event => showProductDetailModal(row)
          }, [_createElementVNode("span", _hoisted_23, _toDisplayString(row.prodNo), 1)], 8, _hoisted_22), _createElementVNode("div", {
            class: "product-link",
            onClick: $event => showProductDetailModal(row)
          }, [_createElementVNode("span", _hoisted_25, _toDisplayString(row.prodName), 1)], 8, _hoisted_24)])]),
          businessShelfStatus: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_tag, {
            type: getStatusType(row.isSell)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(getBusinessShelfStatusText(row.isSell)), 1)]),
            _: 2
          }, 1032, ["type"])])]),
          teamShelfStatus: _withCtx(({
            row
          }) => [_createVNode(_component_el_switch, {
            class: "team-shelf-switch",
            size: "large",
            "model-value": Number(row.supplierSellStatus) === 0 ? 0 : 1,
            "active-value": 1,
            "inactive-value": 0,
            "active-text": "上架",
            "inactive-text": "下架",
            "inline-prompt": "",
            disabled: !_unref(canEditTeamSellStatus),
            onChange: v => teamSellStatusChange(v, row)
          }, null, 8, ["model-value", "disabled", "onChange"])]),
          storageInfo: _withCtx(({
            row
          }) => [_createVNode(_component_el_popover, {
            placement: "right",
            trigger: "hover",
            width: "400"
          }, {
            reference: _withCtx(() => [_createElementVNode("span", {
              class: "storage-number",
              onMouseenter: $event => loadStorageDetails(row)
            }, _toDisplayString(row.storageNumber), 41, _hoisted_27)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: storageDetailsData.value,
              style: {
                "width": "100%"
              },
              "max-height": "300"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "ware_house_id",
                label: "仓库",
                width: "100"
              }), _createVNode(_component_el_table_column, {
                prop: "owner_id",
                label: "货位",
                width: "150"
              }), _createVNode(_component_el_table_column, {
                prop: "available_storage_number",
                label: "可售库存",
                width: "80"
              })]),
              _: 1
            }, 8, ["data"])), [[_directive_loading, storageDetailsLoading.value]])])]),
            _: 2
          }, 1024)]),
          specificationInfo: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", null, _toDisplayString(row.prodSpecification), 1), _createElementVNode("div", null, _toDisplayString(row.manufacturer), 1)])]),
          teamIncomePriceInfo: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_30, [row.supMerchandisePriceList && row.supMerchandisePriceList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(row.supMerchandisePriceList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, _toDisplayString(item.areaLevelName) + "：" + _toDisplayString(item.supIncomePrice || '-'), 1);
          }), 128)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_31], 64)), __props.dept.levelType === '0' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: $event => editTeamPrice(row),
            link: "",
            icon: "Edit",
            type: "primary",
            style: {
              "position": "absolute",
              "right": "10px",
              "top": "50%",
              "transform": "translateY(-50%)"
            }
          }, null, 8, ["onClick"])) : _createCommentVNode("", true)])]),
          teamSalePriceInfo: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_32, [row.supMerchandisePriceList && row.supMerchandisePriceList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(row.supMerchandisePriceList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, _toDisplayString(item.areaLevelName) + "：" + _toDisplayString(item.supSalePrice || '-'), 1);
          }), 128)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_33], 64)), __props.dept.levelType === '0' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: $event => editTeamPrice(row),
            link: "",
            icon: "Edit",
            type: "primary",
            style: {
              "position": "absolute",
              "right": "10px",
              "top": "50%",
              "transform": "translateY(-50%)"
            }
          }, null, 8, ["onClick"])) : _createCommentVNode("", true)])]),
          blacklistSalesmanInfo: _withCtx(({
            row
          }) => [row.blacklistSalesmanNumber > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(row.blacklistSalesmanNumber) + " 人 ", 1)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_35], 64)), _unref(isRootDept) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: $event => editMerchandiseBlacklist(row),
            link: "",
            icon: "Edit",
            type: "primary",
            style: {
              "position": "absolute",
              "right": "10px",
              "top": "50%",
              "transform": "translateY(-50%)"
            }
          }, null, 8, ["onClick"])) : _createCommentVNode("", true)]),
          _: 1
        }, 16)) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(UploadModal, {
        modelValue: showUploadModel.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showUploadModel.value = $event),
        option: _unref(uploadOption),
        onSuccess: uploadSuccess
      }, {
        help: _withCtx(() => [_hoisted_36, _hoisted_37, _hoisted_38, _hoisted_39]),
        _: 1
      }, 8, ["modelValue", "option"]), _createVNode(AddDrugsModal, {
        modelValue: showAddDrugsModal.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => showAddDrugsModal.value = $event),
        supplierId: __props.supplierId,
        dept: __props.dept,
        storageType: __props.storageType,
        onSuccess: _cache[7] || (_cache[7] = $event => table.value.commitProxy('reload'))
      }, null, 8, ["modelValue", "supplierId", "dept", "storageType"]), _createVNode(AddCategoryModal, _mergeProps({
        modelValue: showAddCateModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showAddCateModal.value = $event),
        categoryList: categoryList.value,
        data: selectCategory.value
      }, props, {
        onSuccess: updateCategorySuccess
      }), null, 16, ["modelValue", "categoryList", "data"]), _createVNode(SelectCategoryModal, {
        modelValue: showSelectCateModal.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => showSelectCateModal.value = $event),
        categoryList: categoryList.value,
        onSuccess: updateDrugsCategorySuccess
      }, null, 8, ["modelValue", "categoryList"]), _createVNode(UpdateBottomPriceModal, {
        modelValue: showUpdateBottomPriceModal.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showUpdateBottomPriceModal.value = $event),
        data: selectedRow.value,
        supplierId: __props.supplierId,
        onSuccess: updatebottomPriceSuccess
      }, null, 8, ["modelValue", "data", "supplierId"]), _createVNode(EditTeamPriceModal, {
        modelValue: showTeamPriceModal.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showTeamPriceModal.value = $event),
        data: selectedTeamPriceRow.value,
        onSuccess: handleTeamPriceSuccess
      }, null, 8, ["modelValue", "data"]), _createVNode(_component_el_dialog, {
        modelValue: drugEqualModal.show,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => drugEqualModal.show = $event),
        title: "价格同步设置",
        width: "500px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = $event => drugEqualModal.show = false)
        }, {
          default: _withCtx(() => [_hoisted_43]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: setSupPriceStrategyFetch
        }, {
          default: _withCtx(() => [_hoisted_44]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_40, _createVNode(_component_el_radio_group, {
          modelValue: drugEqualModal.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => drugEqualModal.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: "1"
          }, {
            default: _withCtx(() => [_hoisted_41]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: "2"
          }, {
            default: _withCtx(() => [_hoisted_42]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(ProductDetailModal, {
        modelValue: showProductDetail.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => showProductDetail.value = $event),
        data: selectedProduct.value
      }, null, 8, ["modelValue", "data"]), _createVNode(MerchandiseBlacklistModal, {
        modelValue: showMerchandiseBlacklistModal.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => showMerchandiseBlacklistModal.value = $event),
        row: selectBlacklistRow.value,
        dept: __props.dept,
        supplierId: __props.supplierId,
        onSuccess: handleTeamPriceSuccess
      }, null, 8, ["modelValue", "row", "dept", "supplierId"])]);
    };
  }

};